import _ from 'lodash';
import { GET_SENT_EXAMS } from '../actions/answersActions';

/**
 * Manejo de la parte del estado correspondiente a exámenes enviados.
 * Permite la actualización de exámenes enviados.
 *
 * @export
 * @param {*} [state={}] : estado de la aplicación
 * @param {*} action : operación a realizar sobre el estado (correspondiente a los exámenes enviados)
 * @returns El estado con la modificación/acción realizada.
 */
export default function(state = {}, action) {
  switch (action.type) {
    case GET_SENT_EXAMS:
      const sentExams = action.payload.exams;
      const pagination = action.payload.links;
      return {...state, sentExams: sentExams, pagination: pagination};
    default:
      return state;
  }
} 